import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Switch, Route as PublicRoute } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard";
import ManagementHub from "../pages/ManagementHub";
import CampaignsHub from "../pages/CampaignsHub";
import FlowHub from "../pages/FlowHub";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup";
import Login from "../pages/Login";
import Connections from "../pages/Connections";
import SettingsCustom from "../pages/SettingsCustom";
import Financeiro from "../pages/Financeiro";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts";
import ContactImportPage from "../pages/Contacts/import";
import ChatMoments from "../pages/Moments"
import Queues from "../pages/Queues";
import Tags from "../pages/Tags";
import MessagesAPI from "../pages/MessagesAPI";
import Helps from "../pages/Helps";
import ContactLists from "../pages/ContactLists";
import ContactListItems from "../pages/ContactListItems";
import Companies from "../pages/Companies";
import QuickMessages from "../pages/QuickMessages";
import { AuthProvider } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { CurrencyProvider } from "../context/Currency/CurrencyContext";
import Route from "./Route";
import Schedules from "../pages/Schedules";
import Clinic from "../pages/Clinic";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import AllConnections from "../pages/AllConnections";
import Reports from "../pages/Reports";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
// import Integrations from '../pages/Integrations';
// import GoogleCalendarComponent from '../pages/Integrations/components/GoogleCalendarComponent';
import FlowBuilder from "../pages/FlowBuilder";
import CampaignsPhrase from "../pages/CampaignsPhrase";
import QueueIntegration from "../pages/QueueIntegration";
// import Files from "../pages/Files"; // REMOVIDO: Lista de arquivos não é mais usado
import ToDoList from "../pages/ToDoList";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban";
import ForgotPassword from "../pages/ForgetPassWord";
import GoogleMapsScraper from "../pages/GoogleMapsScraper";
import KnowledgeBase from "../pages/KnowledgeBaseHub";
import ResetPassword from "../pages/ResetPassword";
import Subscribers from "../pages/Subscribers";
import Affiliates from "../pages/Affiliates";
import PaymentConfig from "../pages/PaymentConfig";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfUse from "../pages/TermsOfUse";
import DataDeletion from "../pages/DataDeletion";


const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  // Rotas 100% publicas - fora de qualquer provider de autenticacao
  const publicPaths = ["/politicas", "/termos", "/exclusao-dados"];
  const isPublicPage = publicPaths.includes(window.location.pathname);

  if (isPublicPage) {
    return (
      <BrowserRouter>
        <Switch>
          <PublicRoute exact path="/politicas" component={PrivacyPolicy} />
          <PublicRoute exact path="/termos" component={TermsOfUse} />
          <PublicRoute exact path="/exclusao-dados" component={DataDeletion} />
        </Switch>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <AuthProvider>
        <CurrencyProvider>
          <TicketsContextProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <Route exact path="/signup/:lang" component={Signup} />
            <Route exact path="/pt/registre-se" component={Signup} />
            <Route exact path="/cadastre-se" component={Signup} />
            <Route exact path="/en/sign-up" component={Signup} />
            <Route exact path="/sign-up" component={Signup} />
            <Route exact path="/es/registrarse" component={Signup} />
            <Route exact path="/registrarse" component={Signup} />
            <Route exact path="/tr/kayit-ol" component={Signup} />
            <Route exact path="/kayit-ol" component={Signup} />
            <Route exact path="/ar/register" component={Signup} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/reset-password" component={ResetPassword} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/financeiro" component={Financeiro} isPrivate />

                <Route exact path="/companies" component={Companies} isPrivate />
                <Route exact path="/" component={ManagementHub} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={TicketResponsiveContainer} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/quick-messages" component={QuickMessages} isPrivate />
                <Route exact path="/todolist" component={ToDoList} isPrivate />
                <Route exact path="/schedules" component={Schedules} isPrivate />
                <Route exact path="/clinic" component={Clinic} isPrivate />
                <Route exact path="/tags" component={Tags} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/contacts/import" component={ContactImportPage} isPrivate />
                <Route exact path="/helps" component={Helps} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/messages-api" component={MessagesAPI} isPrivate />
                <Route exact path="/settings" component={SettingsCustom} isPrivate />
                <Route exact path="/settings/:tab" component={SettingsCustom} isPrivate />
                <Route exact path="/queues" component={Queues} isPrivate />
                <Route exact path="/reports" component={ManagementHub} isPrivate />
                <Route exact path="/queue-integration" component={QueueIntegration} isPrivate />
                <Route exact path="/announcements" component={Annoucements} isPrivate />
                <Route exact path="/phrase-lists" component={FlowHub} isPrivate />
                <Route exact path="/flowbuilders" component={FlowHub} isPrivate />
                <Route
                  exact
                  path="/flowbuilder/:id?"
                  component={FlowBuilderConfig}
                  isPrivate
                />
                <Route exact path="/chats/:id?" component={Chat} isPrivate />
                {/* REMOVIDO: Lista de arquivos não é mais usado */}
                {/* <Route exact path="/files" component={Files} isPrivate /> */}
                <Route exact path="/moments" component={ManagementHub} isPrivate />
                <Route exact path="/kanban" component={Kanban} isPrivate />
                <Route exact path="/tagsKanban" component={TagsKanban} isPrivate />
                <Route exact path="/prompts" component={Prompts} isPrivate />
                <Route exact path="/allConnections" component={AllConnections} isPrivate />
                <Route exact path="/google-maps-scraper" component={GoogleMapsScraper} isPrivate />
                <Route exact path="/knowledge-base" component={KnowledgeBase} isPrivate />
                <Route exact path="/knowledge-base-qualify" component={KnowledgeBase} isPrivate />
                <Route exact path="/subscribers" component={Subscribers} isPrivate />
                <Route exact path="/affiliates" component={Affiliates} isPrivate />
                <Route exact path="/payment-config" component={PaymentConfig} isPrivate />
                {showCampaigns && (
                  <>
                    <Route exact path="/contact-lists" component={CampaignsHub} isPrivate />
                    <Route exact path="/contact-lists/:contactListId/contacts" component={ContactListItems} isPrivate />
                    <Route exact path="/campaigns" component={CampaignsHub} isPrivate />
                    <Route exact path="/campaign/:campaignId/report" component={CampaignReport} isPrivate />
                  </>
                )}
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          {typeof document !== "undefined" &&
            ReactDOM.createPortal(
              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnFocusLoss={false}
                pauseOnHover
              />,
              document.body
            )}
          </TicketsContextProvider>
        </CurrencyProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
